import { createFileRoute } from "@tanstack/react-router";
import { historyQueryOptions } from "@/lib/client/review";
import {
  historySearchSchema,
  HistorySearchParams,
  ReviewHistoryPage,
} from "@/features/user/history-page";

export const Route = createFileRoute("/_index/_authed/history")({
  component: RouteComponent,
  staticData: {
    title: "申请记录",
  },
  validateSearch: historySearchSchema,
  loaderDeps: (opts) => opts.search,
  async loader({ context, deps }) {
    await context.queryClient.ensureInfiniteQueryData(historyQueryOptions(deps));
  },
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { queryClient, user } = Route.useRouteContext();

  const handleTabChange = (tab: HistorySearchParams["tab"]) => {
    navigate({
      search: {
        ...search,
        tab,
      },
      replace: true,
    });
  };

  return (
    <ReviewHistoryPage
      queryClient={queryClient}
      search={search}
      user={user!}
      onTabChange={handleTabChange}
    />
  );
}
